import { PrimaryButton, RadioButton, SecondaryButton, Typography } from '@weareopenr/component-library';
import { FieldValues, useForm } from 'react-hook-form';

import { ButtonContainer } from 'src/components/ButtonContainer/ButtonContainer';

type Props = {
  onCancel: () => void;
  onSubmit: (t: TSelectPriceSchemeSchema['scheme']) => void;
};

export type TSelectPriceSchemeSchema = {
  scheme: 'create' | 'import';
};

const defaultValues = { scheme: undefined } satisfies FieldValues;

const SelectSchemeTypeStep = ({ onSubmit, onCancel }: Props) => {
  const form = useForm<FieldValues>({
    defaultValues,
  });

  const submitStep = ({ scheme }: TSelectPriceSchemeSchema) => {
    onSubmit(scheme);
  };

  return (
    <form onSubmit={form.handleSubmit(submitStep)}>
      <Typography size="large" weight="bold">
        Create from:
      </Typography>
      <fieldset style={{ border: 'none', padding: 0, margin: 0, marginTop: 16 }}>
        <RadioButton name="scheme" value="create" register={form.register}>
          <span>
            <Typography size="medium" weight="semi-bold">
              Create empty scheme
            </Typography>
            <Typography size="small">Start fresh with an empty price scheme</Typography>
          </span>
        </RadioButton>
        <RadioButton name="scheme" value="import" register={form.register}>
          <span>
            <Typography size="medium" weight="semi-bold">
              Upload from a CSV
            </Typography>
            <Typography size="small">Upload a spreadsheet containing your latest pricing.</Typography>
          </span>
        </RadioButton>
      </fieldset>
      <ButtonContainer
        left={
          <SecondaryButton data-cy="cancel-button" buttonStyle="outline" onClick={onCancel} size="full-width">
            Cancel
          </SecondaryButton>
        }
        right={
          <PrimaryButton data-cy="create-button" disabled={!form.formState.isDirty} size="full-width" type="submit">
            Continue
          </PrimaryButton>
        }
      />
    </form>
  );
};

export default SelectSchemeTypeStep;
